export enum LandingType {
    VIDEO = 0,
    PARALLAX = 1,
    UNITY = 2,
    INTERACTIVE_MAP = 3,
    PARALLAX_UNITY = 4,
    EMAIL_GATHER = 5,
    ACTOR_SELECT = 6,
    INTERACTIVE_ONE_MAP = 7,
    LANDSHIFT = 8,
    INTERACTIVE_BATTLE = 9,
    INTERACTIVE_PUZZLE = 10,
    PRELAND = 11,
    MOBILE = 12,
    GAMBLE_CHESTS = 13,
    INSTANT_REG = 14
}
